
      import { ConsoleLogger, checkLoafSupport } from "/main.js";

      const logger = new ConsoleLogger(document.getElementById("output"));
      const slowBtn1 = document.getElementById("slowBtn1");
      const slowBtn2 = document.getElementById("slowBtn2");
      const slowBtn3 = document.getElementById("slowBtn3");
      const clearBtn = document.getElementById("clearBtn");

      // Contadores
      let criticalCount = 0;
      let highCount = 0;
      let mediumCount = 0;

      // Verificar soporte
      checkLoafSupport();

      // Función de categorización (igual que main.js pero con más detalle)
      function getFrameSeverity(blockingDuration) {
        if (blockingDuration > 200) {
          return {
            level: "critical",
            label: "Crítico",
            color: "#d32f2f",
            icon: "🔴",
          };
        }

        if (blockingDuration > 100) {
          return {
            level: "high",
            label: "Alto",
            color: "#f57c00",
            icon: "🟡",
          };
        }

        if (blockingDuration > 50) {
          return {
            level: "medium",
            label: "Medio",
            color: "#1a73e8",
            icon: "🔵",
          };
        }

        return {
          level: "low",
          label: "Bajo",
          color: "#388e3c",
          icon: "🟢",
        };
      }

      // Actualizar contadores en la UI
      function updateStats() {
        document.getElementById("criticalCount").textContent = `🔴 Críticos: ${criticalCount}`;
        document.getElementById("highCount").textContent = `🟡 Altos: ${highCount}`;
        document.getElementById("mediumCount").textContent = `🔵 Medios: ${mediumCount}`;
      }

      // Configurar observer con filtrado
      const observer = new PerformanceObserver((list) => {
        for (const entry of list.getEntries()) {
          const severity = getFrameSeverity(entry.blockingDuration);

          // Incrementar contador
          if (severity.level === "critical") criticalCount++;
          else if (severity.level === "high") highCount++;
          else if (severity.level === "medium") mediumCount++;

          updateStats();

          // Mostrar en output con color según severidad
          logger.log("");
          logger.log(`${severity.icon} Frame ${severity.label} detectado`);
          logger.log(`   • Blocking duration: ${entry.blockingDuration}ms`);
          logger.log(`   • Duration total: ${entry.duration}ms`);
          logger.log(`   • Scripts: ${entry.scripts.length}`);

          // Mostrar nombres de funciones si hay
          if (entry.scripts.length > 0) {
            entry.scripts.forEach((script, i) => {
              if (script.sourceFunctionName) {
                logger.log(
                  `   • Script ${i + 1}: ${script.sourceFunctionName} (${script.duration}ms)`,
                );
              }
            });
          }

          logger.log("");

          // Diferentes acciones según severidad
          switch (severity.level) {
            case "critical":
              logger.warn("⚠️  ACCIÓN REQUERIDA: Frame crítico debe ser optimizado urgentemente");
              // En producción: sendAlert(entry)
              break;

            case "high":
              logger.warn("⚠️  RECOMENDADO: Priorizar optimización de este frame");
              // En producción: logToServer(entry)
              break;

            case "medium":
              logger.log("ℹ️  INFO: Frame aceptable pero mejorable");
              // En producción: solo loggear en desarrollo
              break;
          }

          logger.log("─────────────────────────────────────");
        }
      });

      try {
        observer.observe({
          type: "long-animation-frame",
          buffered: true,
        });
      } catch (e) {
        logger.error("Error al configurar observer:", e.message);
      }

      // Generar frames de diferentes severidades
      slowBtn1.addEventListener("click", function generateCriticalFrame() {
        logger.log("🔴 Generando frame CRÍTICO (250ms)...");
        blockMainThread(250);
        slowBtn1.textContent = "Frame crítico generado ✓";
        setTimeout(() => {
          slowBtn1.textContent = "Crítico (250ms)";
        }, 1000);
      });

      slowBtn2.addEventListener("click", function generateHighFrame() {
        logger.log("🟡 Generando frame ALTO (150ms)...");
        blockMainThread(150);
        slowBtn2.textContent = "Frame alto generado ✓";
        setTimeout(() => {
          slowBtn2.textContent = "Alto (150ms)";
        }, 1000);
      });

      slowBtn3.addEventListener("click", function generateMediumFrame() {
        logger.log("🔵 Generando frame MEDIO (75ms)...");
        blockMainThread(75);
        slowBtn3.textContent = "Frame medio generado ✓";
        setTimeout(() => {
          slowBtn3.textContent = "Medio (75ms)";
        }, 1000);
      });

      // Función helper para bloquear el main thread
      function blockMainThread(duration) {
        const start = performance.now();
        while (performance.now() - start < duration) {
          Math.random() * Math.random();
        }
      }

      // Función para mostrar mensaje inicial
      function showInitialMessage() {
        logger.log("👋 Haz clic en los botones para generar frames de diferentes severidades");
        logger.log("📌 Observa cómo cada uno se categoriza automáticamente");
        logger.log("");
      }

      // Limpiar
      clearBtn.addEventListener("click", () => {
        logger.clear();
        criticalCount = 0;
        highCount = 0;
        mediumCount = 0;
        updateStats();
        showInitialMessage();
      });

      // Mensaje inicial
      showInitialMessage();
    